import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Route değiştiğinde scroll'u en üste al
    window.scrollTo(0, 0);
  }, [pathname]);

  // Component mount olduğunda (sayfa yenilendiğinde) scroll'u en üste al
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default ScrollToTop;
